import { inject, injectable } from "@launchtray/tsyringe-async";
import { SceneManager } from "../../../../scene/SceneManager";
import { ModuleFlowExecutor } from "../../../composition/module/ModuleFlowExecutor";
import { TopPanel } from "../../game/components/toppanel/TopPanel";
import { EditPriceModule } from "./EditPriceModule";
import { ILogger } from "../../../logger/ILogger";
import { EditPricePopupScene } from "./scene/EditPricePopupScene";
import { ShowEditPriceSceneParams } from "./scene/ShowEditPriceSceneParams";
import { CancellationToken } from "../../../../shared/async/CancellationToken";
import { CongratulationsPopupScene } from "../congratulations/CongratulationsPopupScene";
import { WarningMessagePopupScene } from "./warningmessage/WarningMessagePopupScene";

export type EditPricePopupSceneFactory = (showParams: ShowEditPriceSceneParams) => Promise<EditPricePopupScene>;
export type WarningMessagePopupSceneFactory = () => Promise<WarningMessagePopupScene>;
export type CongratulationsPopupSceneFactory = (isAddToMarketplace: boolean, cancellationToken: CancellationToken) => Promise<CongratulationsPopupScene>;

@injectable()
export class EditPriceModuleFlowExecutor extends ModuleFlowExecutor<EditPriceModule, boolean> {
    private readonly sceneManager: SceneManager;
    private readonly topPanel: TopPanel;
    private readonly logger: ILogger;

    public constructor(
        sceneManager: SceneManager,
        topPanel: TopPanel,
        @inject("ILogger") logger: ILogger
    ) {
        super();
        this.sceneManager = sceneManager;
        this.topPanel = topPanel;
        this.logger = logger;
    }

    public async execute(module: EditPriceModule, showParams?: ShowEditPriceSceneParams): Promise<boolean> {
        const topPanelOnNofification = this.topPanel.onNotificationLayer;
        try {
            this.topPanel.bringToOriginParent(true);
            const sceneFactory: EditPricePopupSceneFactory = await module.resolve("EditPricePopupSceneFactory");
            const scene = await sceneFactory(showParams);

            const result = await this.sceneManager.showViewableAsync(scene);
            if (topPanelOnNofification) {
                this.topPanel.bringToFront(true);
            }
            return result;
        }
        catch (e: unknown) {
            this.logger.error("Exception on executing ShopModule flow: ", e);
        }
        finally {
            if (topPanelOnNofification) {
                this.topPanel.bringToFront();
            }
        }
    }
}
